import React, { useRef, useState } from 'react';
import styles from '../assets/css/Home.module.css';
import heroImg from '../assets/images/Source code-amico.svg';
import emailjs from '@emailjs/browser';

import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

import ParticleBackground from '../components/ParticleBackground';
import { useScroll, useTransform, motion } from 'framer-motion';
import { FaShieldAlt, FaRocket, FaDatabase } from 'react-icons/fa';

import { useNavigate } from 'react-router-dom';

function Home() {
  const { scrollY } = useScroll();
  const parallaxY = useTransform(scrollY, [0, 300], [0, 100]);
  const formRef = useRef();
  const [sending, setSending] = useState(false);
  const navigate = useNavigate();

  const fadeUp = {
    hidden: { opacity: 0, y: 40 },
    visible: { opacity: 1, y: 0, transition: { duration: 0.6 } }
  };

  const sendEmail = (e) => {
    e.preventDefault();
    setSending(true);

    emailjs.sendForm(
      'service_i04zmhe',
      'template_k16imly',
      formRef.current,
      'Pjj50iK_a-F_z6pX2'
    )
    .then(() => {
      toast.success('✅ ¡Mensaje enviado con éxito!');
      formRef.current.reset();
      setSending(false);
    })
    .catch((error) => {
      console.error('Error al enviar el mensaje:', error);
      toast.error('❌ Ocurrió un error al enviar el mensaje.');
      setSending(false);
    });
  };

  return (
    <div className={styles.container}>
      <ParticleBackground />
      <ToastContainer position="bottom-right" autoClose={4000} />

      {/* HERO */}
      <section className={styles.hero}>
        <div className={styles.heroContent}>
          <motion.div
            className={styles.heroText}
            initial="hidden"
            whileInView="visible"
            viewport={{ amount: 0.3 }}
            variants={fadeUp}
          >
            <h1>Digitalización para Farmacias y Coseguros</h1>
            <p>Transformamos procesos lentos en flujos automáticos, seguros y profesionales.</p>
            <button
              className={styles.cta}
              onClick={() => {
                window.scrollTo({ top: document.body.scrollHeight, behavior: 'smooth' });
              }}
            >
              Contactanos
            </button>
          </motion.div>

          <motion.div className={styles.heroImage} style={{ y: parallaxY }}>
            <img src={heroImg} alt="Dashboard ilustrado" />
          </motion.div>
        </div>
      </section>

      {/* PROBLEMAS */}
      <section className={styles.problemSolution}>
        <motion.h2
          initial="hidden"
          whileInView="visible"
          viewport={{ amount: 0.2 }}
          variants={fadeUp}
        >
          Digitalizá tu proceso en minutos
        </motion.h2>

        <div className={styles.cards}>
          {[{
            icon: <FaRocket className={styles.icon} />,
            title: 'Procesos lentos',
            desc: 'El papeleo es cosa del pasado. Digitalizamos tus flujos en segundos.'
          }, {
            icon: <FaShieldAlt className={styles.icon} />,
            title: 'Verificación manual',
            desc: 'Automatizamos validaciones con precisión y velocidad.'
          }, {
            icon: <FaDatabase className={styles.icon} />,
            title: 'Datos desconectados',
            desc: 'Centralizá tus datos y hacé reportes en tiempo real.'
          }].map((card, i) => (
            <motion.div
              key={i}
              className={styles.card}
              initial="hidden"
              whileInView="visible"
              viewport={{ amount: 0.2 }}
              variants={{
                hidden: { opacity: 0, y: 40 },
                visible: { opacity: 1, y: 0, transition: { duration: 0.6, delay: i * 0.2 } }
              }}
            >
              {card.icon}
              <h3>{card.title}</h3>
              <p>{card.desc}</p>
            </motion.div>
          ))}
        </div>
      </section>

      {/* FORMULARIO */}
      <section className={styles.formSection}>
        <motion.div
          className={styles.formContainer}
          initial="hidden"
          whileInView="visible"
          viewport={{ amount: 0.2 }}
          variants={fadeUp}
        >
          <h2>¿Querés más información?</h2>
          <p>Dejanos tus datos y te contactamos a la brevedad.</p>

          <form ref={formRef} onSubmit={sendEmail} className={styles.contactForm}>
            <motion.input
              type="text"
              name="name"
              placeholder="Nombre completo"
              required
              whileFocus={{ scale: 1.02 }}
            />
            <motion.input
              type="text"
              name="title"
              placeholder="Farmacia o entidad"
              required
              whileFocus={{ scale: 1.02 }}
            />
            <motion.textarea
              name="message"
              rows="4"
              placeholder="Consulta"
              required
              whileFocus={{ scale: 1.02 }}
            />
            <motion.button
              type="submit"
              disabled={sending}
              className={sending ? styles.sending : ''}
              whileHover={!sending ? { scale: 1.05 } : {}}
              whileTap={!sending ? { scale: 0.95 } : {}}
            >
              {sending ? 'Enviando...' : 'Enviar mensaje'}
            </motion.button>
          </form>
        </motion.div>
      </section>
    </div>
  );
}

export default Home;
